/* LAYALA theme scripts: header shadow, drawers, add-to-cart for looks / complete-the-look / product builder, sticky CTA. */
(function () {
  var LY = (window.LY = window.LY || {});
  var money = function (cents) {
    var v = cents / 100;
    return '₪' + (Number.isInteger(v) ? v : v.toFixed(2));
  };
  LY.money = money;

  /* Add several variants to the cart and open Dawn's cart drawer. */
  LY.addItems = function (items) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || 'تعذّرت الإضافة');
        if (drawer && drawer.renderContents) {
          drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
          drawer.renderContents(res.json);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        return res.json;
      });
  };

  /* Header shadow on scroll */
  var header = document.querySelector('.ly-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Close <details> drawers on overlay / escape */
  document.addEventListener('click', function (e) {
    var close = e.target.closest('[data-ly-close]');
    if (close) { var d = close.closest('details'); if (d) d.removeAttribute('open'); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('details.ly-modal[open]').forEach(function (d) { d.removeAttribute('open'); });
  });
  document.querySelectorAll('details.ly-modal').forEach(function (d) {
    d.addEventListener('toggle', function () {
      document.documentElement.style.overflow = d.open ? 'hidden' : '';
      if (d.open) { var i = d.querySelector('input[type=search]'); if (i) setTimeout(function () { i.focus(); }, 50); }
    });
  });

  /* Multi-add blocks: looks and complete-the-look. Each [data-ly-multi] holds rows [data-ly-item]. */
  document.querySelectorAll('[data-ly-multi]').forEach(function (box) {
    var err = box.querySelector('[data-ly-error]');
    var totalEl = box.querySelector('[data-ly-total]');
    var countEl = box.querySelector('[data-ly-count]');
    var refresh = function () {
      var sum = 0, n = 0;
      box.querySelectorAll('[data-ly-item]').forEach(function (row) {
        var on = row.querySelector('[data-ly-on]');
        var active = !on || on.checked;
        row.classList.toggle('is-off', !active);
        if (active) { sum += Number(row.dataset.price || 0); n++; }
      });
      if (totalEl && !box.hasAttribute('data-ly-fixed-total')) totalEl.textContent = money(sum);
      if (countEl) countEl.textContent = n ? n + ' قطع مختارة' : 'اختاري قطعة على الأقل';
    };
    box.addEventListener('change', function () { if (err) err.hidden = true; refresh(); });
    refresh();
    var btn = box.querySelector('[data-ly-add-all]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var items = [], missing = false;
      box.querySelectorAll('[data-ly-item]').forEach(function (row) {
        var on = row.querySelector('[data-ly-on]');
        if (on && !on.checked) return;
        var sel = row.querySelector('select');
        var id = sel ? sel.value : row.dataset.variant;
        if (!id) { missing = true; if (sel) sel.classList.add('is-error'); return; }
        items.push({ id: Number(id), quantity: 1 });
      });
      if (missing) { if (err) { err.hidden = false; err.textContent = 'اختاري المقاس لكل قطعة.'; } return; }
      if (!items.length) return;
      btn.disabled = true;
      LY.addItems(items).catch(function (e) { if (err) { err.hidden = false; err.textContent = e.message; } }).finally(function () { btn.disabled = false; });
    });
  });

  /* Sticky mobile CTA: shows when the main button scrolls away. */
  document.querySelectorAll('[data-ly-sticky]').forEach(function (bar) {
    var target = document.getElementById(bar.dataset.lySticky);
    if (!target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(target);
  });
})();
